import { Component, type PropsWithChildren } from 'react';

/** Garde un message lisible si un écran échoue pendant son rendu, sans exposer le détail de l’erreur. */
export class ErrorBoundary extends Component<PropsWithChildren, { erreur: boolean }> {
  state = { erreur: false };

  static getDerivedStateFromError() {
    return { erreur: true };
  }

  render() {
    if (this.state.erreur) return (
      <main className="pile" style={{ padding: 32 }}>
        <h1>La page n’a pas pu être affichée</h1>
        <p role="alert">Une erreur a interrompu l’affichage. Rechargez l’application pour réessayer.</p>
        <button type="button" className="btn principal" onClick={() => window.location.reload()}>
          Recharger l’application
        </button>
      </main>
    );
    return this.props.children;
  }
}
